export default {
  miningPickaxeCrafting: '镐制作',
  miningDepthDweller: '深度居民',
  miningSmeltery: '冶炼厂',
  miningEnhancement: '增强',
  miningResin: '树脂',
  miningSmoke: '烟雾',
  miningCompressAluminium: '铝压缩',
  miningCompressCopper: '铜压缩',
  miningCompressTin: '锡压缩',
  miningCompressIron: '铁压缩',
  miningCompressTitanium: '钛压缩',
  miningCompressPlatinum: '铂压缩',
  miningCompressIridium: '铱压缩',
  miningCompressOsmium: '锇压缩',
  miningCompressLead: '铅压缩',
  villageBuildings1: '层 1 建筑',
  villageBuildings2: '层 2 建筑',
  villageBuildings3: '层 3 建筑',
  villageBuildings4: '层 4 建筑',
  villageBuildings5: '层 5 建筑',
  villageBuildings6: '层 6 建筑',
  villageBuildings7: '层 7 建筑',
  villageCoinUpgrades: '金币升级',
  villageUpgradeScythe: '镰刀升级',
  villageUpgradeHatchet: '斧头升级',
  villageUpgradePickaxe: '镐子升级',
  villageUpgradeWateringCan: '浇水器可以升级',
  villageUpgradeInvestment: '投资升级',
  villageUpgradeBasics: '基础升级',
  villageUpgradeProcessing: '加工升级',
  villageUpgradePump: '水泵升级',
  villageUpgradeSand: '沙子升级',
  villageUpgradeBook: '书籍升级',
  villageUpgradeAxe: '斧子升级',
  villageUpgradeBomb: '炸弹升级',
  villageUpgradeToll: '收费升级',
  villageUpgradeFishingRod: '鱼竿升级',
  villageUpgradeHolyBook: '圣书升级',
  villageUpgradeBreakthrough: '突破升级',
  villageUpgradeModifiedPlants: '改造植物升级',
  villageUpgradeDopamine: '多巴胺升级',
  villageUpgradeAdrenaline: '肾上腺素升级',
  villageUpgradeSprinkler: '喷头升级',
  villageUpgradeGreed: '贪婪升级',
  villageUpgradeAmbition: '野心升级',
  villageUpgradeUnderstanding: '认知升级',
  villageUpgradeCuriosity: '好奇心升级',
  villageUpgradeWorship: '崇拜升级',
  villageUpgradeBartering: '易货升级',
  villageUpgradeSparks: '火花升级',
  villageOffering1: '供品',
  villageOffering2: '层 2 供品',
  villageOffering3: '层 3 供品',
  villageOffering4: '层 4 供品',
  villageSpecialIngredient: '特殊成分',
  hordeCorruptedFlesh: '掠夺腐化的肉体',
  hordeSacrifice: '牺牲',
  hordeChessItems: '棋具',
  hordeUpgradeRoyalArmor: '皇家盔甲升级',
  hordeUpgradeRoyalStorage: '皇家存储升级',
  hordeUpgradeRoyalButcher: '皇家屠夫升级',
  hordeUpgradeRoyalCrypt: '皇家地窖升级',
  hordeUpgradeRoyalSecret: '皇家秘密升级',
  hordeClassArcher: '射手职业',
  hordeClassMage: '法师职业',
  hordeClassKnight: '骑士职业',
  hordeClassAssassin: '刺客职业',
  hordeClassShaman: '萨满职业',
  hordeClassPirate: '海盗职业',
  hordeClassUndead: '不死职业',
  hordeClassCultist: '信徒职业',
  hordeClassScholar: '学者职业',
  farmDisableEarlyGame: '禁用“第一作物”',
  farmCropExp: '作物经验',
  farmFertilizer: '肥料',
  galleryConversion: '转换',
  galleryInspiration: '灵感',
  galleryAuction: '拍卖',
  galleryDrums: '鼓',
  galleryShape: '形状',
  galleryCanvas: '画布',
  treasureDual: '双宝',
  bloomPoppyFlower: '罂粟',
  bloomIrisFlower: '鸢尾花',
  bloomLilyFlower: '百合',
  bloomOrchidFlower: '兰花',
  bloomCornflowerFlower: '矢车菊',
  summerFestivalTerraform: '地形改造'
};
